<template>
  <div class="main_wrapper">
    <div class="list main_list_table_th page2_list_table_th" style="padding: 10px 0">
      <div class="main_list_table">
        <div class="list-table" v-if="list.length > 0">
          <div v-for="(i,index) in list" :key="index" class="list-table-item" @click="handleCurrentChange(i)">
            <!-- 名称 -->
            <div class="item-name" style="padding-left: 10px">
              {{ i.pjnoticetitle }}
            </div>
            <!-- 交易方式 -->
            <div class="item-way">{{ i.prsflgdesc }}</div>
            <!-- 倒计时 -->
            <div class="item-downtime">
              <div v-if="+i.btnstatus < 5 && i.alertmsg">
                <span>{{ i.alertmsg }}</span>
                <count-down v-if="i.btnstatus !== 5 && i.btnstatusdesc" :enddate="i.enddate"></count-down>
              </div>
            </div>
            <!-- 发布日期 -->
            <div class="item-ctime">
              <template v-if="!!type">{{
              i.pjnoticetime | formatTime
              }}</template>
              <template v-else>{{ i.pjnoticetime | formatTime}}</template>
            </div>
            <!-- 进度/操作 -->
            <div class="item-progress">
              <div style="display: flex; justify-content: center">
                <div v-if="i.btnstatus && i.btnstatusdesc" class="list_btn" :class="{
                  being:
                    i.btnstatus === 2 ||
                    i.btnstatus === 4 ||
                    i.btnstatus === 5,
                }">
                  <div class="button">{{ i.btnstatusdesc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center; font-weight: bold">暂无信息</div>
        <!-- <el-table highlight-current-row @cell-click="handleCurrentChange" :data="list" style="width: 100%">
            <el-table-column prop="pjnoticetitle" label="名称"></el-table-column>
            <el-table-column prop="prsflgdesc" label="交易方式" align="center" width="100"></el-table-column>
            <el-table-column v-if="!query.pjnoticetype"
                             label="倒计时"
                             width="180">
              <template slot-scope="scope">
                <div v-if="+scope.row.btnstatus < 5 && scope.row.alertmsg">
                  <span>{{scope.row.alertmsg}}</span>
                  <count-down v-if="scope.row.btnstatus !== 5 && scope.row.btnstatusdesc"
                              :enddate="scope.row.enddate"></count-down>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="发布日期" align="center" width="150">
              <template slot-scope="scope">
                <div>{{scope.row.projectggfbtime}}</div>
              </template>
            </el-table-column>
            <el-table-column label="进度/操作" width="130">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: center">
                  <div v-if="scope.row.btnstatus && scope.row.btnstatusdesc" class="list_btn"
                       :class="{being: scope.row.btnstatus === 2 || scope.row.btnstatus === 4 || scope.row.btnstatus === 5 }">
                    <div class="button">{{scope.row.btnstatusdesc}}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import dayjs from 'dayjs'
import CountDown from "./CountDown";
import request from "@/utils/request";
import dayjs from "dayjs";
// import _ from 'lodash'
export default {
  name: "ListCard",
  components: { CountDown },
  props: {
    type: Number,
  },
  data() {
    return {
      query: {
        name: "",
        currentPage: 1,
        offset: 0,
        isContent: 0,
      },
      list: [],
    };
  },
  watch: {},
  mounted() { },
  filters: {
    formatTime(val) {
      return dayjs(val).format("YYYY-MM-DD");
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList(val) {
      if (val) {
        this.query.currentPage = 1;
      }
      if (this.query.name === "清空") {
        this.query.name = "";
      }
      this.query.platform = this.platformActiveTab;
      this.query.pjnoticetype = this.type;
      this.query.beginDate = "";
      this.query.endDate = "";
      // this.query.status = this.childActiveTab.index !== 0 ? this.childActiveTab.datawhere : ''
      this.nowdate = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      this.$store.commit("changeState", { searchinfo: this.query.name });
      this.query.limit = 10;
      this.query.cosid = this.cosId;
      this.query.selectField = `pjnoticetitle,prsflg,pjnoticetime,projectggfbtime,pjnoticetype,projecttime,prsbjendtime,prsbmendtime,prsbjbegtime,
        prsbmbegtime,projectjkactualbegtime,projectjkactualendtime,projectisinvite,projectid,pjnoticeid,projectstatus,projectstopflg,projectcancelflg`;
      this.list = [];
      let res = await request({
        url: "/web/web/getPageListForWeb",
        method: "get",
        params: this.query,
      });
      if ([2, 5].includes(this.type)) {
        console.log(res.list)
        res.list = res.list.splice(0,5)
      }
      this.list = res.list;
    },
    handleCurrentChange(val) {
      this.model = val;
      // let obj = this.childActiveTab
      // obj.last = val
      // this.$store.commit('changeState', {'childActiveTab': obj})
      // let menu = this.menus[1]
      // this.$store.commit('changeState', {'parentActiveTab': menu})

      let { href } = this.$router.resolve({
        name: "pjnoticeInfo",
        query: { pjnoticeid: this.model.pjnoticeid, projectid: this.model.projectid },
      });
      window.open(href, "_blank");
    },
  },
  computed: {
    ...mapGetters([
      "menus",
      "parentActiveTab",
      "childActiveTab",
      "searchinfo",
      "cosId",
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .list-table {
    .list-table-item {
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-name {
        flex: 3;
      }

      .item-way {
        flex: 1;
        text-align: center;
      }

      .item-downtime {
        // flex:1;
        width: 143px;
        text-align: center;
      }

      .item-ctime {
        flex: 1;
        text-align: center;
      }

      .item-progress {
        flex: 1;
        text-align: center;
      }
    }

    .list-table-item:hover {
      cursor: pointer;
      background-color: rgb(211, 208, 208);
      // animation: bgcolor 1s linear;
      // animation-fill-mode:forwards;
    }

    // @keyframes bgcolor {
    //   from{
    //     background: #fff;
    //   }
    //   to{
    //     background-color: rgb(212, 212, 212);
    //   }
    // }
  }

  .list {
    .page {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-bg-white;
      padding: 18px 0;
    }

    .list_btn {
      line-height: 30px;
      cursor: pointer;
      color: #ffffff;
      display: flex;

      .button {
        text-align: center;
        width: 70px;
        padding: 2px 3px;
        background-color: $color-orange;
      }
    }

    .being {
      .button {
        background-color: $color-being-green;
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .list-table {
    .list-table-item {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-name {
        flex: 3;
      }

      .item-way {
        flex: 1;
        text-align: center;
      }

      .item-downtime {
        // flex:1;
        width: 143px;
        text-align: center;
      }

      .item-ctime {
        flex: 1;
        text-align: center;
      }

      .item-progress {
        flex: 1;
        text-align: center;
      }
    }

    .list-table-item:hover {
      cursor: pointer;
      background-color: rgb(211, 208, 208);
      // animation: bgcolor 1s linear;
      // animation-fill-mode:forwards;
    }

    // @keyframes bgcolor {
    //   from{
    //     background: #fff;
    //   }
    //   to{
    //     background-color: rgb(212, 212, 212);
    //   }
    // }
  }

  .list {
    .page {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-bg-white;
      padding: 18px 0;
    }

    .list_btn {
      line-height: 30px;
      cursor: pointer;
      color: #ffffff;
      display: flex;

      .button {
        text-align: center;
        width: 70px;
        padding: 2px 3px;
        background-color: $color-orange;
      }
    }

    .being {
      .button {
        background-color: $color-being-green;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .main_wrapper {
    font-size: $fontsize-medium-s;

    .main_list_table {
      overflow: hidden;
      border-radius: 5px;
      padding: 5px 0;
      margin: 0 5px;
      -moz-box-shadow: 1px 1px 7px #9c9c9c;
      -webkit-box-shadow: 1px 1px 7px #9c9c9c;
      box-shadow: 1px 1px 7px #9c9c9c;

      .list-table {
        .list-table-item {
          display: flex;
          justify-content: space-between;
          margin: 25px 0;

          .item-name {
            width: 75%;
          }

          .item-way,
          .item-downtime,
          .item-ctime {
            display: none;
          }

          .item-progress {
            width: 20%;
            padding-right: 5px;

            .list_btn {
              line-height: 30px;
              cursor: pointer;
              color: #ffffff;

              .button {
                text-align: center;
                width: 70px;
                padding: 1px 3px;
                border-radius: 20px;
                background-color: #f46722;
              }
            }

            .being {
              .button {
                background-color: $color-being-green;
              }
            }
          }
        }
      }
    }
  }
}
</style>
